<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  height: 21vh;
  margin: 0px auto;
  color: #fff;
  text-align: center;
  overflow: hidden;

  .main {
    width: 100%;
    height: 100%;

    .swiper-wrap {
      height: 14.9vh;
      overflow: hidden;
      width: 92%;
    }

    .list-item {
      &:nth-child(even) {
        background: #0B2574;
      }

      width: 100%;
      height: 5vh;
      line-height: 5vh;
      display: flex;
      font-size: 1.8vh;

      .item {
        width: 33%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .list-item1 {
      color: #00FEFB;
      height: 5vh;
      line-height: 5vh;
      display: flex;
      font-size: 2vh;
      margin: 0 auto;
      width: 92%;

      .item {
        width: 33%;
        text-align: center;
      }
    }
  }
}
</style>

<template>
  <boxWrap :name="name" :min="true">
    <div class="table">
      <div class="main">
        <div class="list-item list-item1">
          <div class="item">种植批次</div>
          <div class="item">生产总重量</div>
          <div class="item">报损率</div>
        </div>
        <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="tableData.length != 0">
          <swiper-slide v-for="(item, index) in tableData" :key="index" class="list-item">
            <div class="item name">{{ item.traceBatchName }}</div>
            <div class="item">{{ item.harvestQuantity }}</div>
            <div class="item">{{ item.damagedRatio }}%</div>
          </swiper-slide>
        </swiper>
        <!-- <table>
          <tr class="theader">
            <th>种类</th>
            <th>生产规模</th>
            <th>产值</th>
            <th>产量</th>
            <th>上市周期</th>
          </tr>
          <tr v-for="(item, index) in tableData" :key="index" class="tr">
            <td>{{item.name}}</td>
            <td>{{item.scale}}</td>
            <td>{{item.output}}</td>
            <td>{{item.production}}</td>
            <td>{{item.listed}}</td>
          </tr>
        </table> -->
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from '../common/boxWrap';
// import '/../../../../static/css/swiper.css'
import '@/assets/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      name: '种植批次数据',
      tableData: [],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 180,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  async  mounted() {
    let { err, res } = await this.$model('dataManagement').commonfn2(this.$apiUrl.DATAANALYSIS.GetLastestPickingBatchList);
    if (res.state === 200) {
      let resultData = res.results
      this.tableData = resultData
      // console.log(resultData)
    } else {
      this.$message.showError(err);
    }
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?133946a3